import React from 'react';
import { PhoneIcon, MessageCircleIcon, CalendarIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { BUSINESS_PHONE_HREF, WHATSAPP_URL } from '../data/contact';
import { trackEvent } from '../utils/analytics';
export function StickyMobileBar() {
  const {
    t
  } = useLanguage();
  return <div className="fixed inset-x-0 bottom-0 z-50 md:hidden" data-id="element-429" data-mp="2288gkkr14b86">
      <p className="bg-midnight px-4 py-1.5 text-center text-[10px] uppercase tracking-[0.14em] text-white/70" data-id="element-430" data-mp="1egtaqi01nbs6">
        Avanti Way Realty LLC
      </p>
      <nav aria-label={t('Quick contact', 'Contacto rápido')} className="grid grid-cols-3 border-t border-white/10 bg-navy" data-id="element-431" data-mp="1ahkglc13dbw3">
        <a href={BUSINESS_PHONE_HREF} onClick={() => trackEvent('phone_click', {
        location: 'sticky_bar'
      })} className="flex flex-col items-center gap-1 py-3 text-[10px] uppercase tracking-[0.12em] text-white transition-colors duration-150 ease-out active:bg-midnight" data-id="element-432" data-mp="1jfwg63jxrk0o">
          <PhoneIcon className="h-5 w-5 text-gold" aria-hidden="true" data-id="element-433" data-mp="guoituapll43" />
          {t('Call', 'Llamar')}
        </a>
        <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" onClick={() => trackEvent('whatsapp_click', {
        location: 'sticky_bar'
      })} className="flex flex-col items-center gap-1 border-x border-white/10 py-3 text-[10px] uppercase tracking-[0.12em] text-white transition-colors duration-150 ease-out active:bg-midnight" data-id="element-434" data-mp="lroquar4cxxu">
          <MessageCircleIcon className="h-5 w-5 text-gold" aria-hidden="true" data-id="element-435" data-mp="33jsxjx5876y" />
          WhatsApp
        </a>
        <a href="#contact" onClick={() => trackEvent('schedule_tour_click', {
        location: 'sticky_bar'
      })} className="flex flex-col items-center gap-1 py-3 text-[10px] uppercase tracking-[0.12em] text-white transition-colors duration-150 ease-out active:bg-midnight" data-id="element-436" data-mp="80tfmrt5e4r3">
          <CalendarIcon className="h-5 w-5 text-gold" aria-hidden="true" data-id="element-437" data-mp="3gftwepmxtqzi" />
          {t('Schedule Tour', 'Agendar Visita')}
        </a>
      </nav>
    </div>;
}